<router-outlet></router-outlet>
<p-confirmDialog></p-confirmDialog>
<p-toast [baseZIndex]="200000"></p-toast>
<ui-kovan-global-error-handler></ui-kovan-global-error-handler>
<ui-preloader></ui-preloader>
